import { useState, useEffect, useContext } from "react";
import { UserContext } from "../context/UserContext";
import { getFollowUps } from "../utils/api-lists/doctor.api";


export const useFollowUps = (limit = null) => {
  const { user } = useContext(UserContext);

  const [followUps, setFollowUps] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadFollowUps = async () => {
    if (!user?.id) return;

    setLoading(true);
    try {
      const response = await getFollowUps(user.id);

      // Sort by most urgent / latest (adjust if needed)
      let sorted = [...response].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      if (limit) {
        sorted = sorted.slice(0, limit);
      }

      setFollowUps(sorted.reverse()); // Reverse to show oldest first
    } catch (error) {
      console.error("Error loading follow-ups:", error);
      setFollowUps([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFollowUps();
  }, [user?.id]);

  return { followUps, loading};
};